import PropTypes from 'prop-types'
import {useTranslation} from 'react-i18next'
import {Flex, Box, Text} from '@chakra-ui/react'

import {useRedemptionActivities} from '../../../hooks/useRedemptionActivities'
import RedemptionActivitiesTable from './RedemptionActivitiesTable'
import EmptyState from './EmptyState'

const ActivitiesTab = ({currentSupplier}) => {
  const {t} = useTranslation()

  const {
    activities: redemptionActivities,
    total: redemptionsTotal,
    loading: isLoadingActivities,
  } = useRedemptionActivities(currentSupplier.id)

  return (
    <Flex flex="auto" direction="column" gap="sm">
      <Box flexGrow={1}>
        <Flex direction="column" gap="sm">
          <Box>
            <Text
              textStyle="headline4"
              color="neutral.700"
              textTransform="uppercase"
            >
              {t('points:activitiesScreen.total')}
            </Text>

            <Flex
              direction="row"
              gap="xs"
              pt="sm"
              pb="md"
              alignItems="flex-end"
            >
              <Text textStyle="headline2" color="black">
                {isLoadingActivities
                  ? '...'
                  : redemptionsTotal.toLocaleString()}
              </Text>
              <Text
                textStyle="headline5"
                color="black"
                textTransform="uppercase"
              >
                {t('common:marmaladeRewardCurrency')}
              </Text>
            </Flex>
          </Box>
          {redemptionActivities.length === 0 && !isLoadingActivities ? (
            <EmptyState
              title={t('points:redemptionActivitiesScreen.emptyState.title')}
              description={t(
                'points:redemptionActivitiesScreen.emptyState.description',
              )}
            />
          ) : (
            <RedemptionActivitiesTable
              activities={redemptionActivities}
              isLoading={isLoadingActivities}
            />
          )}
        </Flex>
      </Box>
    </Flex>
  )
}

ActivitiesTab.propTypes = {
  currentSupplier: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
}

export default ActivitiesTab
